var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "custom-page tags-page"
  }, [_c('MainLayout', {
    scopedSlots: _vm._u([{
      key: "mainLeft",
      fn: function () {
        return [_vm.$categoriesAndTags.tags.length ? _c('TagsBar', {
          attrs: {
            "tagsData": _vm.$categoriesAndTags.tags,
            "tag": _vm.tag
          }
        }) : _vm._e(), _vm._v(" "), _c('PostList', {
          attrs: {
            "currentPage": _vm.currentPage,
            "perPage": _vm.perPage,
            "tag": _vm.tag
          }
        }), _vm._v(" "), _c('Pagination', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: Math.ceil(_vm.total / _vm.perPage) > 1,
            expression: "Math.ceil(total / perPage) > 1"
          }],
          attrs: {
            "total": _vm.total,
            "perPage": _vm.perPage,
            "currentPage": _vm.currentPage
          },
          on: {
            "getCurrentPage": _vm.handlePagination
          }
        })];
      },
      proxy: true
    }, {
      key: "mainRight",
      fn: function () {
        return [_vm.$categoriesAndTags.tags.length ? _c('TagsBar', {
          attrs: {
            "tagsData": _vm.$categoriesAndTags.tags,
            "tag": _vm.tag
          }
        }) : _vm._e()];
      },
      proxy: true
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };